import {
  UPDATE_SEARCH,
  UPDATE_LAST_SUGGESTION,
  UPDATE_SEARCH_FROM_LOCAL_STORAGE,
} from './constants'

export const updateSearchAction = payload => ({
  type: UPDATE_SEARCH,
  payload,
})

export const updateSearchActionFromLocalStorage = () => ({
  type: UPDATE_SEARCH_FROM_LOCAL_STORAGE,
})

export const updateLastSuggestion = payload => ({
  type: UPDATE_LAST_SUGGESTION,
  payload,
})
